import type { FaireProductEntity } from "../../entity_types/product";

export const p_7sjmkmsftk: FaireProductEntity = {
  token: "p_7sjmkmsftk",
  type: "product",
  name: "Gold Alloy Daisy Charm",
  brandToken: "b_zk22fce9kn",
  brandName: "Love, Paige Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/5710cf1a3c6e5ce592a1e8f07b5c8b0a5cd2caa3c72f9e997d871cae335fa370.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc4c6c400d1b52ac4d38785965546b638f7222f5e1be91c22b107b3feeb84f78.jpeg",
    "https://cdn.faire.com/fastly/41d58f78185f2213cfe83fee8dbc909769aeb98b1717e49743c07904052a8db3.jpeg",
    "https://cdn.faire.com/fastly/2368af3ff1e7efbf5b76ea7ce52d747447a21416ac3fe815cf28cfe5ea663c55.png",
  ],
  priceDollars: 1.72,
  description:
    "Brighten up your jewelry collection with these daisy flower charms, featuring cheerful enamel petals in fun, colorful shades for a playful retro-inspired look. Perfect for bracelets, necklaces, earrings, and custom jewelry designs, these floral charms bring a fresh spring-and-summer feel to any creation. A standout addition for charm bar display setups, gift shops, and boutique collections, they’re a fun way for retailers to add trendy flower jewelry supplies customers will love.\n\nDETAILS:\nAlloy & Enamel\n16x13x2mm",
  tags: [],
  msrpDollars: 4.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:27.987Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
